/**
 * Default exports
 */
export default {
  computed: {
    session_loggedUser: {
      get() {
        return this.$store.getters.loggedUser;
      },
      set(value) {
        this.$store.commit("setLoggedUser", value);
      }
    },

    session_loggedIn: {
      get() {
        return !!this.$store.getters.loggedUser;
      },
      set(value) {
        value === false && this.$store.commit("setLoggedUser", undefined);
      }
    },

    session_isAdmin() {
      return this.$store.getters.isAdmin;
    },
  }
};
